const formatFontName = (rawFont) => {
    return rawFont.split(':')[0];
};

const generateGoogleFontUrl = (font) => {
    const encoded = font.replace(/\s+/g, '+');

    return `https://fonts.googleapis.com/css2?family=${encoded}&display=swap`;
};

const loadGoogleFont = (fontName) => {
    const id = "dynamic-google-font";
    document.getElementById(id)?.remove();

    const link = document.createElement("link");
    link.id = id;
    link.rel = "stylesheet";
    link.href = generateGoogleFontUrl(fontName);
    document.head.appendChild(link);

    const formattedFont = formatFontName(fontName);

    document.body.style.fontFamily = `'${formattedFont}', sans-serif`;
};

export { loadGoogleFont, generateGoogleFontUrl };